<template>
  <article class="article">
    <div class="heading-container">
      <img
        v-if="previewImageSrc"
        class="previw-image"
        :src="previewImageSrc"
        :alt="previewImageAlt"
      />
      <div>
        <h1>{{title}}</h1>
        <blockquote v-if="quote">
          <p v-html="quote"></p>
          <footer v-if="quoteAuthor" class="blockquote-footer">
            <cite :title="quoteAuthor">{{quoteAuthor}}</cite>
          </footer>
        </blockquote>
      </div>
    </div>
    <div class="article-content">
      <slot>No content provided!</slot>
    </div>
  </article>
</template>

<script>
export default {
  name: 'StandardArticle',
  props: [
    'title',
    'quote',
    'quote-author',
    'preview-image-src',
    'preview-image-alt'
  ]
}
</script>

<style lang="scss" scoped>
.article {
  padding: 150px 0 0 0;
}

.heading-container {
  padding: 0 10% 50px 10%;
  display: flex;
  align-items: flex-start;
  h1 {
    font-size: 52px;
    margin-top: 0;
    margin-bottom: 20px;
  }
}

.previw-image {
  margin-right: 20px;
  max-width: 40%;
}

blockquote {
  border: 3px solid #42b983;
  padding: 0 10px 10px 10px;
  border-radius: 10px;
  margin-left: 0;
  margin-top: 0;
}

cite::before {
  content: "- ";
}

.article-content {
  background-color: #fff;
  color: #000;
  padding: 10px 10% 50px 10%;
  img {
    max-height: 400px;
    max-width: 100%;
  }
  a {
    color: #000;
  }
}

@media screen and (max-width: 770px) {
  .previw-image {
    display: none;
  }
}
</style>
